import { render, staticRenderFns } from "./NotificationRutify.vue?vue&type=template&id=2e28d752&scoped=true&"
import script from "./NotificationRutify.vue?vue&type=script&lang=js&"
export * from "./NotificationRutify.vue?vue&type=script&lang=js&"
import style0 from "./NotificationRutify.vue?vue&type=style&index=0&id=2e28d752&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e28d752",
  null
  
)

export default component.exports